import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { 
  Box, 
  Button, 
  Container, 
  Typography, 
  Paper,
  Grid
} from '@mui/material';
import { 
  SentimentDissatisfied as SadIcon,
  Home as HomeIcon
} from '@mui/icons-material';

const NotFound = () => {
  return (
    <Container maxWidth="md">
      <Paper 
        elevation={3} 
        sx={{ 
          p: 5, 
          mt: 5, 
          borderRadius: 2,
          textAlign: 'center'
        }}
      >
        <Grid container spacing={2} direction="column" alignItems="center">
          <Grid item>
            <SadIcon sx={{ fontSize: 100, color: 'text.secondary', mb: 2 }} />
          </Grid>
          <Grid item>
            <Typography variant="h2" component="h1" gutterBottom>
              404
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="h4" component="h2" gutterBottom>
              Page Not Found
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" color="text.secondary" paragraph>
              The page you are looking for doesn't exist or has been moved.
            </Typography>
          </Grid>
          <Grid item sx={{ mt: 2 }}>
            <Button 
              variant="contained" 
              color="primary" 
              component={RouterLink} 
              to="/"
              startIcon={<HomeIcon />}
              size="large"
            >
              Back to Home
            </Button>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default NotFound;
